import React, {useState} from 'react';
import '../Demo.scss';
import {
  Step,
  ArrStepper,
} from '../../../components/common/arr-stepper/ArrStepper';
import ArrButton from '../../../components/common/arr-button/ArrButton';
import {Typography} from '@mui/material';
export default function WizardDemo() {
  const [steps, setSteps] = useState<Step[]>([
    {
      key: 'step1',
      label: 'Step 1',
      state: 'current',
      tooltip: 'Fill in project details before proceeding.',
    },
    {key: 'step2', label: 'Step 2', state: 'future'},
    {key: 'step3', label: 'Step 3', state: 'future'},
    {key: 'step4', label: 'Step 4', state: 'future'},
    {key: 'step5', label: 'Step 5', state: 'future'},
    {key: 'step6', label: 'Step 6', state: 'future'},
  ]);

  const currentIndex = steps.findIndex((s) => s.state === 'current');

  const goNext = () => {
    setSteps((prev) =>
      prev.map((step, i) =>
        i === currentIndex
          ? {...step, state: 'completed'}
          : i === currentIndex + 1
            ? {...step, state: 'current'}
            : step
      )
    );
  };

  const goPrevious = () => {
    setSteps((prev) =>
      prev.map((step, i) =>
        i === currentIndex
          ? {...step, state: 'future'}
          : i === currentIndex - 1
            ? {...step, state: 'current'}
            : step
      )
    );
  };

  return (
    <div className="stepper-container">
      <Typography component="h1" className="typo-text headline1_size">
        Stepper
      </Typography>
      <ArrStepper
        steps={steps}
        currentStepKey={steps[currentIndex]?.key || ''}
        allowNonLinear={true}
        onStepChange={(key) => {
          setSteps((prev) =>
            prev.map((s) =>
              s.key === key
                ? {...s, state: 'current'}
                : s.state === 'current'
                  ? {...s, state: 'completed'}
                  : s
            )
          );
        }}
      />
      <div className="stepper-content">
        <p>{`This is Step ${currentIndex + 1} content.`}</p>
      </div>
      <div className="stepper-buttons">
        <ArrButton
          onClick={goPrevious}
          disabled={currentIndex === 0}
          dataTestId="wizard-stepper-demo-previous-button">
          Previous
        </ArrButton>
        <ArrButton
          onClick={goNext}
          disabled={currentIndex === steps.length - 1}
          dataTestId="wizard-stepper-demo-next-button">
          Next
        </ArrButton>
      </div>
    </div>
  );
}
